import { Reveal } from "./Reveal";
import SectionHead from "./SectionHead";

const BillardIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="3.6" />
    <text x="12" y="13.8" textAnchor="middle" fontSize="5.5" fill="currentColor" stroke="none" fontFamily="Georgia, serif">8</text>
  </svg>
);

const DartIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
    <circle cx="10" cy="14" r="7.5" />
    <circle cx="10" cy="14" r="4.2" />
    <circle cx="10" cy="14" r="1.2" fill="currentColor" stroke="none" />
    <path d="M13.5 10.5 20 4" />
    <path d="M17 4h3v3" />
  </svg>
);

const KickerIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
    <rect x="2.5" y="4" width="19" height="16" rx="1" />
    <line x1="8" y1="2.5" x2="8" y2="21.5" />
    <line x1="16" y1="2.5" x2="16" y2="21.5" />
    <circle cx="8" cy="9" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="8" cy="14" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="16" cy="11" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

const DrinkIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
    <path d="M4.5 5h15L12 13.5 4.5 5Z" />
    <line x1="12" y1="13.5" x2="12" y2="19.5" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <circle cx="17.5" cy="3.5" r="1.4" />
  </svg>
);

const ITEMS = [
  {
    n: "01",
    Icon: BillardIcon,
    title: "Billard",
    text: "Poolbillard an gepflegten Tischen — Queue, Kreide und gutes Licht sind immer inklusive.",
  },
  {
    n: "02",
    Icon: DartIcon,
    title: "Dart",
    text: "Steel Dart in Ruhe gespielt: klare Abwurflinie, gutes Board, kein Gedränge.",
  },
  {
    n: "03",
    Icon: KickerIcon,
    title: "Kicker",
    text: "Tischkicker für schnelle Matches zwischendurch — zu zweit oder im kleinen Turnier.",
  },
  {
    n: "04",
    Icon: DrinkIcon,
    title: "Drinks & Snacks",
    text: "Klassiker an der Bar und Kleiniges für den Abend — ohne Schnickschnack, dafür mit Stil.",
  },
];

export default function Angebot() {
  return (
    <section id="angebot" data-testid="angebot-section" className="px-6 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-7xl">
        <SectionHead chapter="01" eyebrow="Angebot" title="Alles für deinen Abend." />
        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map(({ n, Icon, title, text }, i) => (
            <Reveal key={n} delay={i * 0.1}>
              <div
                data-testid={`angebot-card-${n}`}
                className="group flex h-full flex-col border border-[#241a15] bg-[#1c1512] p-8 transition-colors duration-500 hover:bg-[#241a15]"
              >
                <div className="flex items-start justify-between">
                  <Icon className="h-10 w-10 text-[#c9a24a] transition-transform duration-500 group-hover:-translate-y-1" />
                  <span className="text-xs tracking-[0.1em] text-[#c9a24a]/50">{n}</span>
                </div>
                <h3 className="mt-10 font-display text-2xl text-[#f4ecdd] transition-colors duration-300 group-hover:text-[#e3c988]">
                  {title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[#c9bda9]">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
